import React from "react";
import {
    InfoIcon,
    CartFilledIcon,
    ListBulletedFilledIcon
} from '@shopify/polaris-icons';
import {Icon} from '@shopify/polaris';
import { useTranslation } from 'react-i18next';

const Tabs = ({hasName, handleLinkClick, activeTab, shoppingComplete, resizeIframe}) => {
    const { t } = useTranslation();

    // Calculate number of tabs
    const numberOfTabs = hasName ? 3 : 2;

    return (
        <>
            <div className={"bottom-border"}></div>
            <nav className={`crew-cart-tabs tabs-${numberOfTabs}`}>
                <style>{`
        .crew-cart-tabs {
          display: grid;
          width: 100%;
          max-width: 600px;
          gap: 2px;
          margin: 0 auto;
          background: white;
          padding: 10px 0;
        }

        /* Grid templates for different number of tabs */
        .tabs-2 {
          grid-template-columns: repeat(2, minmax(0, 200px));
          justify-content: center;
        }

        .tabs-3 {
          grid-template-columns: repeat(3, 1fr);
        }

        .crew-cart-tabs a {
          display: grid;
          place-items: center;
          text-decoration: none;
          color: black;
          font-weight: bold;
          cursor: pointer;
        }

        .crew-cart-tabs .icon-container {
          margin: 0 auto 4px auto;
          width: 25px;
          height: 25px;
        }

        .crew-cart-tabs span {
          display: block;
          text-align: center;
        }
      `}</style>

                {/* Rest of your tabs code remains the same */}
                <a href="#"
                   onClick={(e) => {
                       e.preventDefault();

                           handleLinkClick("crewcart");

                   }}
                   aria-disabled={shoppingComplete}
                   className={activeTab === "crewcart" ? 'active' : ''}
                >
                    <div className={shoppingComplete ? "icon-container disabled" : "icon-container"}>
                        <Icon
                            source={CartFilledIcon}
                            tone="base"
                        />
                    </div>
                    <span>{t('tabs.crewcart')}</span>
                </a>

                {hasName && (
                    <a href="#"
                       onClick={(e) => {
                           e.preventDefault();
                           handleLinkClick("cart-overview");
                           resizeIframe();
                       }}
                       className={activeTab === "cart-overview" ? "active" : ""}
                    >
                        <div className="icon-container">
                            <Icon
                                source={ListBulletedFilledIcon}
                                tone="base"
                            />
                        </div>
                        <span>{t('tabs.cartOverview')}</span>
                    </a>
                )}

                <a href="#"
                   onClick={(e) => {
                       e.preventDefault();
                       handleLinkClick("info");
                       resizeIframe();
                   }}
                   className={activeTab === "info" ? "active" : ""}
                >
                    <div className="icon-container">
                        <Icon
                            source={InfoIcon}
                            tone="base"
                        />
                    </div>
                    <span>{t('tabs.info')}</span>
                </a>
            </nav>
        </>
    );
}

export default Tabs;
